import { combineReducers } from 'redux';

import dashboard from '../individualPortal/dashboard/dashboardReducer';
import applications from './applications/applicationsReducer';
import communicationPreferences, * as fromCommunicationPreferences
    from './communicationPreferences/communicationPreferencesReducer';
import eligibilityResults from './eligibilityResults/eligibilityResultsReducer';
import ticket from '../individualPortal/ticket/ticketReducer';
import ticketFile from '../individualPortal/ticket/ticketFileReducer';
import secureInbox from '../individualPortal/secureInbox/secureInboxReducer';
import customGrouping from './customGrouping/customGroupingReducer';
import enrollmentHistory from './enrollmentHistory/enrollmentHistoryReducer';

export default combineReducers({
    dashboard,
    applications,
    communicationPreferences,
    eligibilityResults,
    secureInbox,
    ticket,
    ticketFile,
    customGrouping,
    enrollmentHistory
});

// Selectors

export const selectMailingAddressFromComPref =
    state => fromCommunicationPreferences.selectMailingAddressFromComPref(state.communicationPreferences);